import uz  from './../lang/uz'
import ru  from './../lang/ru'
import en  from './../lang/en'

import Vue from "vue"
export const langState = {
    lang: {
        uz, ru, en
    },
    currentLang: "ru",
};

export const langMutations = {
    changeCurrentLanguage(state, value){
        state.currentLang = value;
    }
};
